import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ReportPrint from "@/pages/ReportPrint";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import Terms from "@/pages/legal/Terms";
import Disclaimer from "@/pages/legal/Disclaimer";
import "@/pages/ReportPrint.css";

function App() {
    return (
        <div className="App font-body">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/report/print/:id" element={<ReportPrint />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
